import { toNameWords } from './clientName';

export const GENERATOR_ERRORS = {
  REQUIRED: 'required',
  INVALID_NAME: 'invalid-name',
  INVALID_ID: 'invalid-id',
  INVALID_COLOR: 'invalid-color',
  DUPLICATED_ID: 'duplicated-id',
  INVALID_FILE: 'invalid-file',
};

const POSITIVE_INTEGER = /^[1-9]\d*$/;
const STARTS_WITH_LETTER = /^[a-z]/;
export const HEX_COLOR = /^#[0-9a-fA-F]{6}$/;

// A extensão vai para o import e para o nome do arquivo: só formatos que o webpack carrega
export const IMAGE_EXTENSIONS = ['png', 'jpg', 'jpeg', 'webp', 'svg'];

export const getFileExtension = file => {
  const parts = file.name.split('.');
  return parts.length > 1 ? parts.pop().toLowerCase() : '';
};

const isBlank = value => !String(value ?? '').trim();

const validateClientName = clientName => {
  if (isBlank(clientName)) return GENERATOR_ERRORS.REQUIRED;

  const [firstWord] = toNameWords(clientName);
  return STARTS_WITH_LETTER.test(firstWord || '')
    ? null
    : GENERATOR_ERRORS.INVALID_NAME;
};

const validatePersonContextId = (personContextId, existingIds) => {
  if (isBlank(personContextId)) return GENERATOR_ERRORS.REQUIRED;

  const trimmedId = String(personContextId).trim();
  if (!POSITIVE_INTEGER.test(trimmedId)) return GENERATOR_ERRORS.INVALID_ID;

  return existingIds.includes(Number(trimmedId))
    ? GENERATOR_ERRORS.DUPLICATED_ID
    : null;
};

const validateColor = color => {
  if (isBlank(color)) return GENERATOR_ERRORS.REQUIRED;
  return HEX_COLOR.test(color) ? null : GENERATOR_ERRORS.INVALID_COLOR;
};

const validateFile = file => {
  if (!file) return GENERATOR_ERRORS.REQUIRED;
  return IMAGE_EXTENSIONS.includes(getFileExtension(file))
    ? null
    : GENERATOR_ERRORS.INVALID_FILE;
};

export const validateGeneratorForm = (values, existingIds = []) => {
  const errors = {
    clientName: validateClientName(values.clientName),
    personContextId: validatePersonContextId(
      values.personContextId,
      existingIds,
    ),
    primaryColor: validateColor(values.primaryColor),
    secondaryColor: validateColor(values.secondaryColor),
    logoFile: validateFile(values.logoFile),
    bannerFile: validateFile(values.bannerFile),
  };

  return Object.fromEntries(
    Object.entries(errors).filter(([, error]) => error),
  );
};
